'use strict';
/*
 * « Votre appareil » (02/11) : marque > modele, puis les pieces de la famille pour ce modele,
 * affichees sur place (snippets/k-choix-appareil.liquid).
 *
 * Un seul moteur pour la page famille et le Finder par type de piece :
 *   - modeles de la famille : JSON en ligne (page famille) ou section k-pieces-appareil ;
 *   - pieces : section k-pieces-appareil filtree par la valeur du filtre « Modele ».
 * Aucun saut de page : rien n'est fait defiler, l'adresse est mise a jour (?modele=)
 * pour etre partagee. Le Finder change de famille par KrepiteChoixAppareil.famille(el, url).
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  var SECTION = 'k-pieces-appareil';

  /* Libelles compares sans casse ni accents (« Lotus LIVA 6 » = « Lotus Liva 6 »). */
  function norme(v) {
    return String(v || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function lireJson(el, defaut) {
    if (!el) return defaut;
    try { return JSON.parse(el.textContent || ''); } catch (e) { return defaut; }
  }

  function track(event, detail) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: 'choix_appareil_' + event }, detail || {}));
    } catch (e) { /* rien */ }
  }

  function apercu() {
    return new URLSearchParams(window.location.search).get('preview_theme_id');
  }

  function urlSection(familleUrl, param, valeur) {
    var u = new URL(familleUrl, window.location.origin);
    u.searchParams.set('section_id', SECTION);
    if (valeur) u.searchParams.set(param, valeur);
    var p = apercu();
    if (p) u.searchParams.set('preview_theme_id', p);
    return u.pathname + u.search;
  }

  function memoriser(info) {
    var KDM = window.KrepiteDeviceMemory;
    if (!KDM || typeof KDM.set !== 'function' || !info || !info[2]) return;
    KDM.set({ model_handle: info[2], brand_handle: info[0], brand_label: info[1],
      model_label: info.label, variant: null });
  }

  function appareilMemorise() {
    var KDM = window.KrepiteDeviceMemory;
    var d = KDM && typeof KDM.get === 'function' ? KDM.get() : null;
    if (!d) return '';
    var nom = d.model_label || '';
    if (d.brand_label && nom.indexOf(d.brand_label) !== 0) nom = d.brand_label + ' ' + nom;
    return nom;
  }

  function vider(select, libelle) {
    while (select.options.length) select.remove(0);
    var o = document.createElement('option');
    o.value = '';
    o.textContent = libelle;
    select.appendChild(o);
  }

  function ajouter(select, valeur, libelle) {
    var o = document.createElement('option');
    o.value = valeur;
    o.textContent = libelle;
    select.appendChild(o);
  }

  function Choix(root) {
    this.root = root;
    this.param = root.getAttribute('data-param');
    var brut = lireJson(root.querySelector('[data-k-pa-index]'), {});
    this.index = {};
    for (var k in brut) if (Object.prototype.hasOwnProperty.call(brut, k)) this.index[norme(k)] = brut[k];
    this.marque = root.querySelector('[data-k-pa-marque]');
    this.modele = root.querySelector('[data-k-pa-modele]');
    this.res = root.querySelector('[data-k-pa-resultats]');
    this.modeles = [];
    this.requete = 0;
    var self = this;
    this.marque.addEventListener('change', function () { self.surMarque(true); });
    this.modele.addEventListener('change', function () { self.surModele(true); });
    var inline = root.querySelector('[data-k-pa-modeles]');
    var url = root.getAttribute('data-famille-url');
    if (inline) this.charger(lireJson(inline, []), url);
    else if (url) this.famille(url);
  }

  Choix.prototype.info = function (label) {
    var i = this.index[norme(label)];
    if (!i) return null;
    return { 0: i[0], 1: i[1], 2: i[2], label: label };
  };

  Choix.prototype.famille = function (url) {
    var self = this;
    this.root.setAttribute('data-famille-url', url || '');
    this.vider();
    if (!url) return Promise.resolve();
    var n = ++this.requete;
    this.root.setAttribute('aria-busy', 'true');
    return fetch(urlSection(url, this.param, ''), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (n !== self.requete) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        self.charger(lireJson(doc.querySelector('[data-k-pa-modeles]'), []), url);
      })
      .catch(function () { if (n === self.requete) self.charger([], url); })
      .then(function () { self.root.removeAttribute('aria-busy'); });
  };

  Choix.prototype.vider = function () {
    vider(this.marque, 'Choisir la marque');
    vider(this.modele, 'Choisir le modèle');
    this.modele.disabled = true;
    this.res.innerHTML = '';
    this.modeles = [];
  };

  /* Modeles de la famille -> marques (celles qui ont au moins un modele ici). */
  Choix.prototype.charger = function (liste, url) {
    var self = this;
    // Modele voulu lu AVANT toute remise a zero (elle retire ?modele= de l'adresse).
    var voulu = new URLSearchParams(window.location.search).get('modele') || appareilMemorise();
    this.root.setAttribute('data-famille-url', url || '');
    this.modeles = (liste || []).map(function (m) {
      var info = self.info(m.v);
      return { v: m.v, n: m.n, marque: info ? info[0] : '', marqueLabel: info ? info[1] : 'Autres' };
    });
    vider(this.marque, 'Choisir la marque');
    var vues = {};
    this.modeles.slice().sort(function (a, b) { return a.marqueLabel.localeCompare(b.marqueLabel, 'fr'); })
      .forEach(function (m) {
        if (vues[m.marqueLabel]) return;
        vues[m.marqueLabel] = true;
        ajouter(self.marque, m.marqueLabel, m.marqueLabel);
      });
    this.root.classList.toggle('is-vide', !this.modeles.length);
    if (!this.modeles.length) {
      this.marque.disabled = true;
      this.statut('Les pièces de cette famille ne dépendent pas d’un modèle. Cherchez-les par leur référence ou dans la liste.');
      return;
    }
    this.marque.disabled = false;
    // Une seule marque : deja choisie.
    if (this.marque.options.length === 2) this.marque.selectedIndex = 1;
    this.surMarque(false);
    // Modele de l'adresse, sinon l'appareil memorise s'il a des pieces ici.
    var trouve = voulu ? this.modeles.filter(function (m) { return norme(m.v) === norme(voulu); })[0] : null;
    if (trouve) {
      this.marque.value = trouve.marqueLabel;
      this.surMarque(false);
      this.modele.value = trouve.v;
      this.surModele(false);
    }
  };

  Choix.prototype.statut = function (texte) {
    this.res.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'k-pa__aide';
    p.textContent = texte;
    this.res.appendChild(p);
  };

  /* Etat vide (02/11) : Braise, ce qui se passe, puis ce que l'on fait pour le client (TON_DE_VOIX). */
  Choix.prototype.vide = function (modele) {
    this.res.innerHTML = '';
    var boite = document.createElement('div');
    boite.className = 'k-pa__vide';
    var src = this.root.getAttribute('data-braise-vide');
    if (src) {
      var img = document.createElement('img');
      img.className = 'k-pa__braise';
      img.src = src; img.alt = ''; img.width = 64; img.height = 64;
      boite.appendChild(img);
    }
    var texte = document.createElement('div');
    var t = document.createElement('p');
    t.className = 'k-pa__statut';
    t.textContent = 'Pas encore de pièce de ce type pour votre ' + modele + '.';
    var a = document.createElement('p');
    a.className = 'k-pa__rassure';
    a.textContent = 'Cherchez-la par sa référence, ou ouvrez les schémas de votre appareil : chaque pièce y est repérée.';
    texte.appendChild(t); texte.appendChild(a);
    boite.appendChild(texte);
    this.res.appendChild(boite);
  };

  Choix.prototype.surMarque = function (parUtilisateur) {
    var self = this;
    var marque = this.marque.value;
    vider(this.modele, 'Choisir le modèle');
    this.res.innerHTML = '';
    if (!marque) { this.modele.disabled = true; if (parUtilisateur) this.adresse(''); return; }
    this.modeles.filter(function (m) { return m.marqueLabel === marque; })
      .sort(function (a, b) { return a.v.localeCompare(b.v, 'fr', { numeric: true }); })
      .forEach(function (m) { ajouter(self.modele, m.v, m.v + ' (' + m.n + ')'); });
    this.modele.disabled = false;
    if (this.modele.options.length === 2) {
      this.modele.selectedIndex = 1;
      this.surModele(parUtilisateur);
      return;
    }
    if (parUtilisateur) { track('marque', { marque: marque }); this.adresse(''); }
  };

  Choix.prototype.surModele = function (parUtilisateur) {
    var self = this;
    var valeur = this.modele.value;
    var url = this.root.getAttribute('data-famille-url');
    if (parUtilisateur || valeur) this.adresse(valeur);
    if (!valeur || !url) { this.res.innerHTML = ''; return; }
    if (parUtilisateur) { track('modele', { modele: valeur }); memoriser(this.info(valeur)); }
    var n = ++this.requete;
    this.res.setAttribute('aria-busy', 'true');
    this.res.classList.add('is-chargement');
    fetch(urlSection(url, this.param, valeur), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (n !== self.requete) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rep = doc.querySelector('[data-k-pa-reponse]');
        if (!rep || !rep.querySelector('.k-pa__liste li')) {
          self.vide(valeur);
          return;
        }
        self.res.innerHTML = '';
        while (rep.firstChild) self.res.appendChild(rep.firstChild);
        var braise = self.root.getAttribute('data-braise-trouve');
        var entete = self.res.querySelector('.k-pa__entete');
        if (braise && entete && !entete.querySelector('.k-pa__appareil')) {
          var b = document.createElement('img');
          b.className = 'k-pa__braise';
          b.src = braise; b.alt = ''; b.width = 56; b.height = 56;
          entete.insertBefore(b, entete.firstChild);
        }
        self.root.dispatchEvent(new CustomEvent('k-choix-appareil:rendu', { bubbles: true, detail: { modele: valeur } }));
      })
      .catch(function () {
        if (n === self.requete) self.statut('Le chargement n’a pas abouti. Choisissez à nouveau votre modèle.');
      })
      .then(function () {
        if (n !== self.requete) return;
        self.res.removeAttribute('aria-busy');
        self.res.classList.remove('is-chargement');
      });
  };

  /* Adresse partageable, sans ancre ni rechargement. */
  Choix.prototype.adresse = function (valeur) {
    if (!window.history || !window.history.replaceState) return;
    var u = new URL(window.location.href);
    if (valeur) u.searchParams.set('modele', valeur);
    else u.searchParams.delete('modele');
    window.history.replaceState(window.history.state, '', u.pathname + u.search);
  };

  /* Choix d'un modele depuis l'exterieur (suggestion de la recherche de la page). */
  Choix.prototype.choisir = function (valeur) {
    var m = this.modeles.filter(function (x) { return norme(x.v) === norme(valeur); })[0];
    if (!m) return false;
    this.marque.value = m.marqueLabel;
    this.surMarque(false);
    this.modele.value = m.v;
    this.surModele(true);
    return true;
  };

  var instances = [];
  function init() {
    document.querySelectorAll('[data-k-pa]').forEach(function (el) {
      if (el.__kpa) return;
      el.__kpa = new Choix(el);
      instances.push(el.__kpa);
    });
  }

  window.KrepiteChoixAppareil = {
    famille: function (el, url) { return el && el.__kpa ? el.__kpa.famille(url) : Promise.resolve(); },
    choisir: function (el, valeur) { return !!(el && el.__kpa && el.__kpa.choisir(valeur)); },
    init: init
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
